import React from 'react';

interface IconPencilProps {
    iconClasses?: string;
}

const IconPencil: React.FC<IconPencilProps> = ({ iconClasses }) => {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-pencil ${iconClasses ?? ''}`}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.94043 14.3799L0 16L1.62012 10.0595L5.94043 14.3799ZM13.6318 0.223604C13.9301 -0.0744819 14.4137 -0.0745876 14.7119 0.223604L15.792 1.30368C16.0901 1.60187 16.09 2.08551 15.792 2.38376L15.126 3.04978C15.5328 3.90141 15.3832 4.95278 14.6777 5.65817L6.57715 13.7588L2.25684 9.43845L10.3574 1.33786C11.0628 0.632468 12.1142 0.482783 12.9658 0.88962L13.6318 0.223604ZM4.41699 9.43845L6.57715 11.5986L11.4521 6.7236L9.29199 4.56345L4.41699 9.43845ZM12.5166 2.41794C12.2184 2.11987 11.7357 2.11988 11.4375 2.41794L10.6807 3.17478L12.8408 5.33493L13.5967 4.5781C13.895 4.27984 13.895 3.79627 13.5967 3.49802L12.5166 2.41794Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconPencil;
